import { Page } from '@/core/architecture'

import { PaymentStatusesTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * PaymentStatuses Page
 * Implemented as a practical sample.
 */
export const PaymentStatuses: Page = () => {
  const { state, actions } = useViewModel()

  return <PaymentStatusesTemplate state={state} {...actions} />
}
